<div class="">
  @if (showTitle) {
    <h2 class="text-center">
      Configuración Banco de Preguntas
    </h2>
  }

  <div
    class="my-3 d-flex flex-column flex-sm-row align-items-center justify-content-between w-100"
    >
    @if (showFilters) {
      <div class="d-flex flex-column flex-sm-row align-items-center w-100" style="flex:10;">
        <mat-form-field style="width: 100%">
          <mat-label>Buscar pregunta</mat-label>
          <input
            matInput
            [(ngModel)]="searchTerm"
            (ngModelChange)="filterQuestions()"
            placeholder="Buscar"
            />
        </mat-form-field>
        <mat-form-field style="width: 100%">
          <mat-label>Filtrar por tipo de respuesta</mat-label>
          <mat-select
            [(ngModel)]="selectedResponseType"
            (selectionChange)="filterQuestions()"
            >
            <mat-option [value]="0">Todos</mat-option>
            @for (type of responseType; track type) {
              <mat-option
                [value]="type.id"
                >
                {{ type.responseType }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <div class="d-flex flex-row justify-content-around gap-1 w-100" style="flex:2;">
      <button
        matTooltip="Guardar cambios"
        matTooltipPosition="above"
        mat-mini-fab
        color="warn"
        (click)="saveOrder()"
        [style.visibility]="
          bodyQuestions?.length > 0 && positionChange ? 'visible' : 'hidden'
        "
        >
        <mat-icon>save</mat-icon>
      </button>

      @if (bodyQuestions?.length > 0 && !questionsBank) {
        <button
          matTooltip="Descargar formato actual"
          matTooltipPosition="above"
          mat-mini-fab
          color="accent"
          (click)="getFormAccordingToVersion($event)"
          >
          <mat-icon>file_download</mat-icon>
        </button>
      }

      @if (addQuestion) {
        <button
          matTooltip="Agregar pregunta"
          matTooltipPosition="above"
          mat-mini-fab
          color="primary"
          (click)="addNewQuestion($event)"
          >
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>

  </div>

  <mat-accordion
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    class="example-headers-align panel my"
    >
    @for (data of filteredQuestions; track data; let i = $index) {
      <mat-expansion-panel
        class="panel"
        class="mb-3"
        cdkDrag
        [cdkDragDisabled]="!cdkDragEnabled || isMobile"
        [expanded]="data.questionId == questionId"
        >
        <mat-expansion-panel-header>
          <mat-panel-title class="title" style="align-items: center">
            <h5 class="no-spacing">
              {{data.question}}
            </h5>
          </mat-panel-title>
          <mat-panel-description style="display: flex; justify-content: flex-end">
            @if (questionsBank) {
              <mat-icon
                class="m-2"
                matTooltip="Editar pregunta"
                matTooltipPosition="above"
                color="primary"
                (click)="editQuestion(data)"
                >edit</mat-icon
                >
              }
              <mat-icon
                class="m-2"
                matTooltip="Eliminar pregunta"
                matTooltipPosition="above"
                color="warn"
                (click)="deleteQuestion(data)"
                >delete</mat-icon
                >
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div
        style="
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          width: 100%;
        "
              >
              @if (data?.responses?.length == 1) {
                <div
                  style="width: 100%"
                  class="first-row"
                  >
                  @if (data?.responses[0] == 'Texto') {
                    <div
                      class="row-item"
                      style="display: flex; flex-direction: row"
                      >
                      <mat-form-field>
                        <mat-label>Respuesta</mat-label>
                        <input
                          autocomplete="off"
                          type="text"
                          matInput
                          required
                          #descripcion
                          maxlength="255"
                          />
                        <mat-hint>{{ descripcion.value.length }}/255</mat-hint>
                      </mat-form-field>
                      <button
                        style="margin: 0 10px 0 10px; width: 90px; height: 5%"
                        mat-raised-button
                        >
                        Enviar
                      </button>
                    </div>
                  }
                  @if (data?.responses[0] == 'Numero') {
                    <div
                      class="row-item"
                      style="display: flex; flex-direction: row"
                      >
                      <mat-form-field>
                        <mat-label>Nuevo valor</mat-label>
                        <input
                          autocomplete="off"
                          type="number"
                          matInput
                          required
                          #number
                          oninput="this.value = this.value.slice(0,7)"
                          />
                        <mat-hint>{{ number.value.length }}/7</mat-hint>
                      </mat-form-field>
                      <button
                        style="margin: 0 10px 0 10px; width: 90px; height: 5%"
                        mat-raised-button
                        >
                        Enviar
                      </button>
                    </div>
                  }
                  @if (data?.responses[0] == 'Fecha') {
                    <div
                      class="row-item"
                      style="display: flex; flex-direction: center; width: 100%"
                      >
                      <mat-form-field [appOpenDatepickerOnClick]="picker">
                        <mat-label>Seleccione una fecha</mat-label>
                        <input
                          matInput
                          [matDatepicker]="picker"
                          autocomplete="off"
                          required
                          placeholder="Seleccione una fecha"
                          />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  }
                  @if (data?.responses[0] == 'Imagen') {
                    <div
                      class="row-item"
                      style="display: flex; flex-direction: column; width: 100%"
                      >
                      <div class="containerPhotos">
                        <file-input
                          [params]="fileInput"
                        ></file-input>
                      </div>
                      <div style="display: flex; justify-content: center; margin-top: 10px;">
                        <button
                          style="width: 90px; height: 5%"
                          mat-raised-button
                          >
                          Enviar
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
              @for (res of data.responses; track res; let j = $index) {
                <div>
                  @if (data.responses.length > 1) {
                    <button
                      class="button-response"
                      mat-raised-button
                      >
                      {{ res }}
                    </button>
                  }
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
